module.exports = __webpack_public_path__ + "static/media/sheet-upload.9412ff4e.png";